import { render, staticRenderFns } from "./ElementWidths.vue?vue&type=template&id=da813cec&scoped=true&"
import script from "./ElementWidths.vue?vue&type=script&lang=js&"
export * from "./ElementWidths.vue?vue&type=script&lang=js&"
import style0 from "./ElementWidths.vue?vue&type=style&index=0&id=da813cec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da813cec",
  null
  
)

export default component.exports